<template>
  <div class="list">
    <van-nav-bar :title="'搜索到['+this.keyword+']'+this.total+'条结果'"></van-nav-bar>

    <div class="size-box"></div>
    <van-notice-bar :scrollable="true"
                    :text="this.noticeText"
                    background="#ffffff"
                    color="#000000"
                    left-icon="volume-o"
                    mode="link"
                    speed="30"
                    @click="jump">

    </van-notice-bar>
    <div class="size-box"></div>

    <div style="margin:10px 0;padding:10px;">
      <van-swipe :autoplay="3000">
        <van-swipe-item v-for="(image, index) in images" :key="index" @click="clickSwipeItem(index)">
          <van-image lazy-load fit="cover" radius="20" :src="image" style="border:1px solid #eee;" />
        </van-swipe-item>
      </van-swipe>
    </div>

    <div class="size-box"></div>
    <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
      <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onload"
      >
        <div v-for="(item,index) in data" :key="item.id">
          <div v-if="index!==0 && index%5===0" type="warning">

            <van-cell-group>
              <van-cell center @click="clickPic">
                <template #title >
                  <span style="color: red;font-size: 18px;font-weight: bold;">资源收集不易，点开 不花钱支持一下</span>
                </template>
              </van-cell>
            </van-cell-group>
          </div>
          <van-cell-group>
            <van-cell :url='item.url?item.url:"https://www.bzqll.com/jump.php?id="+item.id'
                      center
                      is-link
                      size="large"
                      title-style="text-align:left;text-overflow:ellipsis;">
              <template #title >
                <span v-html="item.name"></span>
              </template>
              <template #label>
                <span>文件大小: {{item.fileSize}}</span>
              </template>
            </van-cell>
          </van-cell-group>
        </div>


      </van-list>
    </van-pull-refresh>
  </div>
</template>

<script>
import {Cell, CellGroup, Dialog, Icon, List, NavBar, NoticeBar, Popup, PullRefresh, ImagePreview, Image as VanImage,Swipe, SwipeItem  } from 'vant';
import {querySongs} from '../api/index'

export default {
  name: "list",
  components: {
    [ImagePreview.name]: ImagePreview ,
    [List.name]: List,
    [Cell.name]: Cell,
    [VanImage.name]: VanImage,
    [CellGroup.name]: CellGroup,
    [Icon.name]: Icon,
    [NoticeBar.name]: NoticeBar,
    [NavBar.name]: NavBar,
    [Popup.name]: Popup,
    [Dialog.name]: Dialog,
    [PullRefresh.name]: PullRefresh,
    [Swipe.name]: Swipe,
    [SwipeItem.name]: SwipeItem,
  },
  data() {
    return {
      data: [],
      keyword: '',
      sort: ['id,desc'], 
      images: [
        'https://img.gejiba.com/images/3e867c6ef5614ef9adb0d3b7c14f8a71.png',
        'https://img.gejiba.com/images/e45e01c35870dc1c9c556b8356a6d88a.png',
        'https://img.gejiba.com/images/8f74cdd51f240cdb8a78079a4190fb9a.png',
      ],
      // 页码
      page: 0,
      // 每页数据条数
      size: 20,
      // 总数据条数
      total: 0,
      noticeText: '觉得功能好用的话，就把公众号推荐给朋友吧!点我还可以获取更多免费资源和软件！',
      isLoading: false,
      loading: false,
      finished: false,
      show: false,
    };
  },
  methods: {
    onRefresh() {
      this.isLoading = true
      this.page = 0
      this.onload()
    },
    onload() {
      this.loadData();
    },
    loadData() {
      this.loading = true
      const keyword = this.$route.query.keyword
      this.keyword = keyword;
      const sign = this.$route.query.sign
      const timestamp = this.$route.query.timestamp
      querySongs(keyword, sign, timestamp, this.page, this.size).then(res => {
        console.log(res);
        if (res.success){
          const songList = res.result.records
          this.data.push(...songList)
          this.total = res.result.total
          // 加载状态结束
          this.loading = false
          this.isLoading = false
          // 数据全部加载完成
          if (songList.length < 20) {
            this.finished = true
          }
        }else {
          Dialog.alert({
            title: '请求出错',
            message: '请重新从公众号获取链接',
            theme: 'round-button',
          }).then(() => {
            // on close
          });
        }
      })
      this.page = this.page + 1
    },
    jump() {
      const ua = navigator.userAgent;
      const isWx = !!/MicroMessenger/i.test(ua);
      const isQQ = !!/QQ\//i.test(ua);
      if(isWx||isQQ){
        window.location.href = 'https://c.pc.qq.com/middle.html?pfurl=http://www.6yso.com'
      }else {
        window.location.href = 'https://www.6yso.com'
      }
    },
    clickPic(){
      ImagePreview({
        images:['https://sourl.cn/WjdhDh'],
        closeable: true,
      });
    },
    clickSwipeItem(index){
      if(index==0){
        window.location.href = 'https://search.weixin.qq.com/cgi-bin/newsearchweb/userclientjump?path=page/search/christmas_jump&query=指北#wechat_redirect'
      }else if(index == 1){
        window.location.href = 'https://simhaoka.com/phone/index?id=356721F96422770285FF0EC4F36359A9'
      }else if(index == 2){
        const ua = navigator.userAgent;
        const isWx = !!/MicroMessenger/i.test(ua);
        const isQQ = !!/QQ\//i.test(ua);
        if(isWx||isQQ){
          window.location.href = 'https://c.pc.qq.com/middle.html?pfurl=http://www.6yso.com'
        }else {
          window.location.href = 'https://www.6yso.com'
        }
      }
    }
  }
}
</script>
<style scoped>
.size-box {
  width: 100%;
  height: 0.6%;
  background-color: #f7f8fa;
}
</style>
